import { render, staticRenderFns } from "./SmallCar.vue?vue&type=template&id=16b3a106"
import script from "./SmallCar.vue?vue&type=script&lang=js"
export * from "./SmallCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports